(() => {
  const els = document.querySelectorAll('.nm-anim');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach((el) => el.classList.add('nm-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('nm-in'); io.unobserve(e.target); }
    }),
    { rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach((el) => io.observe(el));
})();
